import { useEffect, useState } from "react";
import { comments } from "../data/product";
import RatingStars from "./Rating";
import Modal from "./Modal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../utilis/api";
export const Details = ({ data }) => {
  console.log(data);
  return (
    <div className="space-y-10 px-2 py-6">
      {/* ================= DESCRIPTION ================= */}
      <div className="relative bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-3xl shadow-sm p-8 overflow-hidden">
        {/* decorative blur circle */}
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-gray-200 opacity-30 rounded-full blur-2xl" />

        <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
          ✨ Description
        </h2>

        <div
          className="text-gray-600 leading-relaxed text-[1.05rem]"
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
      </div>

      {/* ================= PRODUCT INFO ================= */}
      <div className="bg-white border border-gray-200 rounded-3xl shadow-sm p-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-6 flex items-center gap-2">
          📦 Product Details
        </h2>

        <div className="grid gap-4">
          {data.product_type && (
            <div className="flex items-center justify-between bg-gray-50 px-4 py-3 rounded-xl hover:bg-gray-100 transition">
              <span className="text-gray-500">Type</span>
              <span className="font-medium text-gray-900">
                {data.product_type}
              </span>
            </div>
          )}

          {data.vendor && (
            <div className="flex items-center justify-between bg-gray-50 px-4 py-3 rounded-xl hover:bg-gray-100 transition">
              <span className="text-gray-500">Vendor</span>
              <span className="font-medium text-gray-900">{data.vendor}</span>
            </div>
          )}

          {data.tags && data.tags.length > 0 && (
            <div className="flex items-start justify-between bg-gray-50 px-4 py-3 rounded-xl hover:bg-gray-100 transition">
              <span className="text-gray-500">Tags</span>
              <span className="font-medium text-gray-900 text-right">
                {data.tags.join(" • ")}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* ================= EXTRA HIGHLIGHT BOX ================= */}
      <div className="bg-black text-white rounded-3xl p-6 shadow-lg">
        <p className="text-sm opacity-80">Premium Product Experience</p>
        <h3 className="text-lg font-semibold mt-1">
          Crafted with attention to detail & quality
        </h3>
      </div>
    </div>
  );
};

export const ShippingInfo = () => {
  return (
    <div className="px-2 py-8 max-w-4xl mx-auto text-gray-800 space-y-8">
      {/* ================= HEADER ================= */}
      <div className="text-center">
        <h1 className="text-3xl sm:text-4xl font-bold">Shipping Information</h1>
        <p className="text-gray-500 mt-2">
          Everything you need to know about delivery & shipping
        </p>
      </div>

      {/* ================= CARD 1 ================= */}
      <div className="bg-white border rounded-2xl shadow-sm p-6 space-y-3">
        <h2 className="text-lg font-semibold">📦 Order Processing</h2>
        <p className="text-gray-600">
          Any orders placed on the weekend will ship the following business day.
        </p>
      </div>

      {/* ================= CARD 2 ================= */}
      <div className="bg-white border rounded-2xl shadow-sm p-6 space-y-3">
        <h2 className="text-lg font-semibold">🚚 Free Shipping</h2>
        <p className="text-gray-600">
          <span className="font-semibold text-black">FREE U.S. Shipping</span>{" "}
          on orders over <span className="font-semibold">$59.95</span>.
        </p>
        <p className="text-gray-600">
          Otherwise, standard shipping fee is{" "}
          <span className="font-semibold">$7.95</span>.
        </p>
      </div>

      {/* ================= CARD 3 ================= */}
      <div className="bg-white border rounded-2xl shadow-sm p-6 space-y-3">
        <h2 className="text-lg font-semibold">⏱ Delivery Time</h2>
        <p className="text-gray-600">
          Ground shipping takes{" "}
          <span className="font-semibold">5–7 business days</span>
          (excluding weekends & holidays).
        </p>
        <p className="text-gray-600">
          Carriers: <span className="font-medium">USPS, FedEx, UPS</span>
        </p>
      </div>

      {/* ================= CARD 4 ================= */}
      <div className="bg-white border rounded-2xl shadow-sm p-6 space-y-4">
        <h2 className="text-lg font-semibold">⚡ Express Shipping Rates</h2>

        <div className="grid gap-3">
          <div className="flex justify-between bg-gray-50 p-3 rounded-xl">
            <span>2nd Day Delivery</span>
            <span className="font-semibold">$24.95</span>
          </div>

          <div className="flex justify-between bg-gray-50 p-3 rounded-xl">
            <span>Next Day Delivery</span>
            <span className="font-semibold">$39.95</span>
          </div>

          <div className="flex justify-between bg-gray-50 p-3 rounded-xl">
            <span>3 Days Delivery</span>
            <span className="font-semibold">$14.95</span>
          </div>
        </div>

        <p className="text-sm text-gray-500">
          * No express shipping to APO, Hawaii, and Puerto Rico
        </p>
      </div>

      {/* ================= CARD 5 ================= */}
      <div className="bg-white border rounded-2xl shadow-sm p-6 space-y-3">
        <h2 className="text-lg font-semibold">🌍 Remote Areas</h2>
        <p className="text-gray-600">
          Alaska, Hawaii, and Puerto Rico delivery may take{" "}
          <span className="font-semibold">7–14 business days</span>.
        </p>
      </div>

      {/* ================= NOTE BOX ================= */}
      <div className="bg-black text-white rounded-2xl p-6 space-y-2">
        <h2 className="text-lg font-semibold">Important Notice</h2>
        <p className="text-sm opacity-80">
          All orders have a 1-day handling time before shipping. Delivery dates
          are not guaranteed as carriers are third-party services.
        </p>
      </div>
    </div>
  );
};

export const ReviewForm = ({ product, onClose }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const { user, token } = useSelector((state) => state.user);
  const [comment, setComment] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault(); // 🚀 stop page reload

    try {
      const payload = {
        comment,
        product: product._id,
      };

      const response = await api.post("/coments/create", payload, {
        headers: { authorization: `Bearer ${token}` },
      });

      if (response.data?.success) {
        toast.success("Comment Successfully added", { autoClose: 3000 });
        onClose();
      } else {
        toast.error(response.data?.meta?.message || "Comment failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";

      toast.error(message, { autoClose: 5000 });
    }
  };
  return (
    <form className="flex flex-col gap-6">
      {/* ⭐ Star Rating */}
      <div className="flex justify-center gap-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`text-3xl cursor-pointer transition duration-200 ${
              star <= (hover || rating)
                ? "text-yellow-400 scale-110"
                : "text-gray-700"
            }`}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          >
            ★
          </span>
        ))}
      </div>

      {/* 👤 Name Input */}
      <div>
        <label className="block text-gray-800 font-semibold mb-2">
          Your Name
        </label>
        <input
          type="text"
          placeholder="Enter your name"
          value={user?.name}
          disabled
          className="w-full p-3 rounded-lg border text-gray-800 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FFDD6A] transition"
        />
      </div>

      {/* 💬 Comment */}
      <div>
        <label className="block text-gray-800 font-semibold mb-2">
          Your Review
        </label>
        <textarea
          rows="4"
          placeholder="Write your review..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full p-3 rounded-lg text-gray-800 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FFDD6A] transition resize-none"
        />
      </div>

      {/* 🚀 Submit Button */}
      <button
        type="button"
        onClick={handleSubmit}
        className="bg-gray-500 text-white font-bold py-3 rounded-lg transition-all duration-300 hover:scale-105"
      >
        Submit Review
      </button>
    </form>
  );
};

export const Comments = ({ title, products }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, token } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  useEffect(() => {
    const getComments = async () => {
      try {
        console.log(products);
        const res = await api.get(`/coments/${products._id}`, {
          headers: { authorization: `Bearer ${token}` },
        });

        if (res.data.success && res.data.data.length > 0) {
          // Comments exist
          setData(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch comments:", error);
        setData([]); // fallback
      }
    };

    if (products?._id) getComments();
  }, [token, products]);
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="max-w-4xl mx-auto text-gray-800">
      {/* ================= HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            Customer Reviews
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            See what others are saying about this product
          </p>
        </div>

        <button
          onClick={handleOpen}
          className="
        px-6 py-3
        rounded-xl
        font-semibold
        bg-black text-white
        hover:bg-gray-900
        transition-all duration-300
        shadow-md hover:shadow-lg
        flex items-center gap-2
      "
        >
          + Write Review
        </button>
      </div>

      {/* ================= REVIEWS ================= */}
      {data && data.length > 0 ? (
        <div className="space-y-5">
          {data.map((comment, index) => (
            <div
              key={index}
              className="
            bg-white
            border border-gray-100
            rounded-2xl
            p-6
            shadow-sm
            hover:shadow-md
            transition-all duration-300
          "
            >
              {/* User row */}
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-bold text-gray-600 uppercase">
                    {comment?.user?.name?.charAt(0)}
                  </div>

                  <div>
                    <h2 className="font-semibold capitalize text-gray-900">
                      {comment?.user?.name}
                    </h2>
                    <p className="text-xs text-gray-400">Verified Buyer</p>
                  </div>
                </div>

                {/* Rating */}
                <div className="scale-90">
                  <RatingStars rating={5} />
                </div>
              </div>

              {/* Comment */}
              <p className="text-gray-600 leading-relaxed pl-1">
                {comment?.comment}
              </p>
            </div>
          ))}
        </div>
      ) : (
        /* ================= EMPTY STATE ================= */
        <div className="text-center py-14 bg-gradient-to-br from-gray-50 to-white border border-dashed border-gray-200 rounded-2xl">
          <div className="text-4xl mb-3">💬</div>

          <h3 className="text-lg font-semibold text-gray-700">
            No Reviews Yet
          </h3>

          <p className="text-gray-500 mt-1">
            Be the first to share your experience
          </p>

          <button
            onClick={handleOpen}
            className="mt-5 px-5 py-2 bg-black text-white rounded-xl hover:bg-gray-900 transition"
          >
            Write First Review
          </button>
        </div>
      )}

      {/* ================= MODAL ================= */}
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title={title}
        children={<ReviewForm product={products} onClose={handleClose} />}
      />
    </div>
  );
};
